module.exports = __webpack_public_path__ + "static/media/10.c03e36df.png";